/* @flow */

import type { Site, ContactPerson, SalesPerson } from './types';
import type { JSONObject, JSON } from 'common/types';
import { object, record, string, nullable } from 'common/json/extract';

type SitesJSON = { [key: string]: JSONObject };
const sitesJSON: SitesJSON = require('railsRoot/config/sites.json');

export default function allSites(): Array<Site> {
  return Object.keys(sitesJSON).map(key => {
    return siteFromJSON(key, sitesJSON[key]);
  });
}

const extractContactPerson: JSON => ContactPerson = object(
  record({
    image: string,
    mail: string,
    name: string,
    phone: string,
    title: string
  })
);

const extractSalesPerson: JSON => SalesPerson = object(
  record({
    first_name: string,
    image: string,
    mail: string,
    name: string,
    phone: nullable(string)
  })
);

function siteFromJSON(key: string, json: JSONObject): Site {
  return {
    key: key,
    locale: requiredString(json.locale),
    baseDomain: requiredString(json.base_domain),
    twitterHandle: optionalString(json.twitter_handle),
    facebookHandle: optionalString(json.facebook_handle),
    googlePlusHandle: optionalString(json.google_plus_handle),
    partnersUrl: optionalString(json.partners_url),
    defaultOgImage: optionalString(json.default_og_image),
    defaultSearchBounds: requiredBounds(json.default_search_bounds),
    defaultMapCenter: requiredLocation(json.default_map_center),
    iso31661Alpha2: optionalString(json.iso_3166_1_alpha_2),
    iso31661Alpha3: optionalString(json.iso_3166_1_alpha_3),
    contactPerson: extractContactPerson(json.contact_person),
    salesPerson: extractSalesPerson(json.sales_person)
  };
}

function requiredString(maybeString): string {
  if (typeof maybeString !== 'string') {
    throw new Error(
      `Expected string, got ${typeof maybeString}: ${String(maybeString)}`
    );
  }
  return maybeString;
}

function optionalString(maybeString): string | null {
  if (typeof maybeString !== 'string') {
    return null;
  }
  return maybeString;
}

type Bounds = [
  [number, number],
  [number, number],
  [number, number],
  [number, number]
];
function requiredBounds(maybeBounds): Bounds {
  /* $FlowFixMe */
  return maybeBounds;
}

function requiredLocation(maybeLocation): [number, number] {
  /* $FlowFixMe */
  return maybeLocation;
}
